import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import {
  // AutoComplete,
  // Badge,
  // Button,
  // Calendar,
  DatePicker,
  // Input,
  List,
  Modal,
  Tooltip,
  message,
} from "antd";
import {
  // SearchOutlined,
  DownloadOutlined,
  // CalendarOutlined,
  FilePdfOutlined,
  PlaySquareOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { chain, filter, find, includes, map, orderBy, uniqBy } from "lodash";

import LoadingPage from "../../components/LoadingPage";
import Error404Page from "../../components/Error404Page";

import { VideoPlayer } from "../videos/VideosList";
import { PDFViewer } from "../reports/ReportsList";

// import { getRobotNovEyeLogs, getRobotNovEyeLog } from "../videos/logsSlice";
import { getRobotNovEyeLogs } from "../videos/logsSlice";
import { getRobotVideos } from "../videos/videoSlice";
// import { getRobotNovDataLogs, getRobotNovDataLog } from "../reports/logsSlice";
import { getRobotNovDataLogs } from "../reports/logsSlice";
import { getRobotReports } from "../reports/reportSlice";
import {
  getRobotWeld,
  getRobotTier,
  updateRobotUsage,
} from "../robot/robotSlice";

import { DATETIME_REGEX, DATE_REGEX, WELD_REGEX } from "../../libs/constants";

import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";

import Moment from "moment";
import { extendMoment } from "moment-range";

import { isEdge, isSafari } from "react-device-detect";

// const VIDEO_PREFIX_OLD = "weld_vision.";
// const VIDEO_PREFIX_NEW = "NovEye.";

// NovEye with H265/HVEC is from '2.3.0'
const NOVEYE_H265_VERSION = "2.3.0";
const WARNING =
  "Of the desktop browsers only Microsoft Edge (version 16 and later) and Safari (version 11 and later) support H.265";

const TOOLTIP_MSG = (
  <span style={{ fontSize: "0.8rem" }}>
    Download limit exceeded
    <br />
    Sorry, you can't view or download at this time.
    Contact Novarc Customer Support to view file or increase limits
  </span>
);

// import { fileSize } from "../../libs/utils";

const moment = extendMoment(Moment);

function RobotSearchFiles(props) {
  const calendarRef = useRef(null);
  const dispatch = useDispatch();
  // const [value, setValue] = useState("");
  // const [keyword, setKeyword] = useState("");

  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalPreviewOpen, setModalPreviewOpen] = useState(false);
  const [modalDateOpen, setModalDateOpen] = useState(false);

  const { robotName } = useParams();
  const robotId =
    robotName && robotName.match(/(\d+)/) && robotName.match(/(\d+)/)[0];

  const robots = useSelector((state) => state.robot.robots);

  const videos = useSelector((state) => state.videos.videos);
  const noveye_logs = useSelector((state) => state.noveye_logs.logs);
  const reports = useSelector((state) => state.reports.reports);
  const novdata_logs = useSelector((state) => state.novdata_logs.logs);
  const selectedNovDataLog = useSelector(
    (state) => state.novdata_logs.selectedItem
  );
  const weldInfo = useSelector((state) => state.robot.weldRun);
  const tier = useSelector((state) => state.robot.tier);

  const { isCustomer } = props;

  useEffect(() => {
    dispatch(getRobotVideos(robotId));
    dispatch(getRobotNovEyeLogs(robotId));
    dispatch(getRobotNovDataLogs(robotId));
    dispatch(getRobotReports(robotId));

    dispatch(getRobotWeld(robotId));
    dispatch(getRobotTier(robotId));
  }, [dispatch, robotId]);

  if (!robotId) {
    return <Error404Page />;
  }

  if (!videos && !noveye_logs && !reports && !novdata_logs && !weldInfo) {
    return <LoadingPage />;
  }

  if (!robots) {
    return <LoadingPage />;
  }

  const robot = robots.find((item) => item.name === robotName);

  if (!robot) {
    return <Error404Page />;
  }

  const { versions = [] } = robot;

  const isNovEyeH265 = !!versions
    .filter((i) => {
      return i.name === "NovEye" || i.name === "WeldVision";
    })
    .map((i) => i.version)
    .find((i) => i >= NOVEYE_H265_VERSION);

  const weldRun = (weldInfo && weldInfo[robotId]) || null;
  const robotTier = (tier && tier[robotId]) || null;

  if (!weldRun) {
    return <LoadingPage />;
  }
  if (!robotTier) {
    return <LoadingPage />;
  }

  const current_files = {};

  const data = {
    videos,
    noveye_logs,
    reports,
    novdata_logs,
  };

  const {
    merged_videos,
    merged_daily_reports,
    merged_novdata_logs,
    merged_noveye_logs,
    dates,
    work_order_ref,
  } = loadData(data, current_files);

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleModalPreviewOpen = (item) => {
    setSelectedItem(item);
    handleUsageUpdate(robotId, { ...item, activity: "preview" });
    setModalPreviewOpen(true);
  };
  const handleModalPreviewClose = () => {
    setModalPreviewOpen(false);
  };

  const handleModalDateClose = () => {
    setModalDateOpen(false);
  };

  const handleUsageUpdate = (robotId, item) => {
    if (isCustomer) dispatch(updateRobotUsage(robotId, item));
  };

  const groupedWeldRun = chain(weldRun)
    .map((item) => {
      const idx = weldRun.findIndex((i) => i === item);
      if (
        idx < weldRun.length - 1 &&
        moment(weldRun[idx + 1].arc_on_utc, "YYYY-MM-DD").diff(
          moment(item.arc_on_utc, "YYYY-MM-DD"),
          "days"
        ) === 0
      ) {
        const duration = moment.duration(
          moment(item.arc_on_utc).diff(moment(weldRun[idx + 1].arc_off_utc))
        );

        return { ...item, duration };
      } else {
        return { ...item };
      }
    })
    .groupBy((item) => {
      return item.work_order_ref + " " + item.spool_ref;
    })
    .entries()
    .map(([work_order_spool, weld]) => {
      const children = orderBy(
        [...weld],
        [
          (i) => {
            return i.run_number;
          },
        ],
        ["desc"]
      );

      const childrenSize = children.length;
      const first = children[0];
      const last = children[childrenSize - 1];

      return {
        key: work_order_spool,
        children,
        title: work_order_spool,
        start: last.arc_on_utc,
        end: first.arc_off_utc,
        work_order_ref: last.work_order_ref,
        spool_ref: last.spool_ref,

        units_system: last.units_system,
        pipe_size_inches: last.pipe_size_inches,
        pipe_schedule: last.pipe_schedule,

        // sum of arc off time (setup time) on grouped weld
        duration: children.slice(1).reduce((prev, curr) => {
          return prev.add(curr.duration);
        }, moment.duration(first.duration)),

        // sum of weld time on grouped weld
        weld_time: children.slice(1).reduce((prev, curr) => {
          return prev.add(curr.weld_time);
        }, moment.duration(first.weld_time))._data,

        weld_inches: last.run_number === 0 ? last.weld_inches : null,
      };
    })
    .value();

  function onChange(date, dateString) {
    // console.log(date, dateString);
    let calendarApi = calendarRef.current.getApi();
    if (date) calendarApi.gotoDate(dateString);
  }

  const isLimitExceeded =
    parseInt(robotTier.used, 10) >= parseInt(robotTier.capacity, 10);

  const filteredWeldRun = weldRun
    .filter((item) =>
      moment(moment(item.arc_on_utc).format("YYYY-MM-DD")).isSame(selectedDate)
    )
    .sort((a, b) => {
      if (a.arc_on_utc > b.arc_on_utc) {
        return 1;
      }
      if (a.arc_on_utc < b.arc_on_utc) {
        return -1;
      } else {
        return 0;
      }
    });

  return (
    <>
      <FullCalendar
        ref={calendarRef}
        headerToolbar={{
          left: "prevYear,prev,today,next,nextYear goToDate",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        height={"90%"}
        customButtons={{
          goToDate: {
            text: (
              <DatePicker
                onChange={onChange}
                dateRender={(current) => {
                  const style = {};

                  if (includes(dates, current.format("YYYY-MM-DD"))) {
                    style.border = "1px solid #1890ff";
                    style.borderRadius = "50%";
                  }

                  return (
                    <div className="ant-picker-cell-inner" style={style}>
                      {current.date()}
                    </div>
                  );
                }}
              />
            ),
          },
        }}
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin]}
        initialView="dayGridMonth"
        events={groupedWeldRun}
        eventClick={(info) => {
          setModalOpen(true);
          dispatch(getRobotTier(robotId));
          setSelectedJob(info.event.extendedProps);
        }}
        navLinks={true}
        navLinkDayClick={(date, jsEvent) => {
          setModalDateOpen(true);
          dispatch(getRobotTier(robotId));
          setSelectedDate(moment(date).format("YYYY-MM-DD"));
        }}
      />
      {!!selectedJob && (
        <Modal
          title={`${selectedJob.work_order_ref} ${selectedJob.spool_ref} (${selectedJob.children.length}) runs`}
          visible={modalOpen}
          // onOk={handleOk}
          onCancel={handleCancel}
          footer={null}
        >
          <List>
            <b>Daily Report</b>
            {/* List of Daily report for arc on date */}
            {selectedJob.children
              .map((item) => {
                return getDailyReport(reports, item);
              })
              .filter((value, index, self) => self.indexOf(value) === index)
              .map((item) => {
                if (item)
                  return (
                    <List.Item
                      actions={[
                        item ? (
                          <span>
                            Preview{" "}
                            <Tooltip
                              title={
                                isLimitExceeded && isCustomer
                                  ? TOOLTIP_MSG
                                  : null
                              }
                            >
                              <FilePdfOutlined
                                style={{
                                  cursor:
                                    isLimitExceeded && isCustomer
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={() =>
                                  isLimitExceeded && isCustomer
                                    ? null
                                    : handleModalPreviewOpen(item)
                                }
                              />
                            </Tooltip>
                          </span>
                        ) : (
                          <LoadingOutlined />
                        ),

                        item ? (
                          <span>
                            Download{" "}
                            <Tooltip
                              title={
                                isLimitExceeded && isCustomer
                                  ? TOOLTIP_MSG
                                  : null
                              }
                            >
                              <a
                                style={{ color: "rgba(0, 0, 0, 0.45)" }}
                                href={
                                  isLimitExceeded && isCustomer
                                    ? null
                                    : item.url
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                              >
                                <DownloadOutlined
                                  style={{
                                    cursor:
                                      isLimitExceeded && isCustomer
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                  onClick={() =>
                                    isLimitExceeded && isCustomer
                                      ? null
                                      : handleUsageUpdate(robotId, item)
                                  }
                                />
                              </a>
                            </Tooltip>
                          </span>
                        ) : (
                          <LoadingOutlined />
                        ),
                      ]}
                    >
                      {item.fileName}
                    </List.Item>
                  );
              })}
            <br></br>
            {/* List of daily report that are corresponding to weld run date should go here */}
            <b>Weld</b>
            {[...selectedJob.children].reverse().map((item, index) => {
              const video = getVideoLink(videos, item);
              const tsv = getNovDataLogLink(novdata_logs, item);
              return (
                <List.Item
                  actions={[
                    video ? (
                      <span>
                        Video{" "}
                        <Tooltip
                          title={
                            isLimitExceeded && isCustomer ? TOOLTIP_MSG : null
                          }
                        >
                          <PlaySquareOutlined
                            style={{
                              cursor:
                                isLimitExceeded && isCustomer
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            onClick={() =>
                              isLimitExceeded && isCustomer
                                ? null
                                : isNovEyeH265 && !(isEdge || isSafari)
                                ? message.error(WARNING, 5)
                                : handleModalPreviewOpen(video)
                            }
                          />
                        </Tooltip>{" "}
                        <a
                          style={{ color: "rgba(0, 0, 0, 0.45)" }}
                          href={
                            isLimitExceeded && isCustomer
                              ? null
                              : (video && video.url) || null
                          }
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Tooltip
                            title={
                              isLimitExceeded && isCustomer ? TOOLTIP_MSG : null
                            }
                          >
                            <DownloadOutlined
                              style={{
                                cursor:
                                  isLimitExceeded && isCustomer
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() =>
                                isLimitExceeded && isCustomer
                                  ? null
                                  : isNovEyeH265 && !(isEdge || isSafari)
                                  ? message.error(WARNING, 5)
                                  : handleUsageUpdate(robotId, video)
                              }
                            />
                          </Tooltip>
                        </a>
                      </span>
                    ) : (
                      <LoadingOutlined />
                    ),
                    tsv ? (
                      <span>
                        NovData{" "}
                        <a
                          style={{ color: "rgba(0, 0, 0, 0.45)" }}
                          href={
                            isLimitExceeded && isCustomer
                              ? null
                              : (tsv && tsv.url) || null
                          }
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Tooltip
                            title={
                              isLimitExceeded && isCustomer ? TOOLTIP_MSG : null
                            }
                          >
                            <DownloadOutlined
                              style={{
                                cursor:
                                  isLimitExceeded && isCustomer
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() =>
                                isLimitExceeded && isCustomer
                                  ? null
                                  : handleUsageUpdate(robotId, tsv)
                              }
                              // onClick={() => handleModalPreviewOpen(tsv)}
                            />
                          </Tooltip>
                        </a>
                      </span>
                    ) : (
                      <LoadingOutlined />
                    ),
                  ]}
                >
                  <span>{`${index + 1} ${item.work_order_ref} ${
                    item.spool_ref
                  } ${item.welder_id_ref} ${item.run_number} ${
                    item.operator_name
                  }`}</span>{" "}
                </List.Item>
              );
            })}
          </List>
        </Modal>
      )}

      {!!selectedDate && (
        <Modal
          title={selectedDate}
          visible={modalDateOpen}
          // onOk={handleModalDateClose}
          onCancel={handleModalDateClose}
          footer={null}
        >
          <List>
            <b>Daily Report</b>
            {[getDailyReport(reports, { arc_on_utc: selectedDate })].map(
              (item) => {
                if (item) {
                  return (
                    <List.Item
                      actions={[
                        item ? (
                          <span>
                            Preview{" "}
                            <Tooltip
                              title={
                                isLimitExceeded && isCustomer
                                  ? TOOLTIP_MSG
                                  : null
                              }
                            >
                              <FilePdfOutlined
                                style={{
                                  cursor:
                                    isLimitExceeded && isCustomer
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={() =>
                                  isLimitExceeded && isCustomer
                                    ? null
                                    : handleModalPreviewOpen(item)
                                }
                              />
                            </Tooltip>
                          </span>
                        ) : (
                          <LoadingOutlined />
                        ),

                        item ? (
                          <span>
                            Download{" "}
                            <a
                              style={{ color: "rgba(0, 0, 0, 0.45)" }}
                              href={
                                isLimitExceeded && isCustomer ? null : item.url
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <Tooltip
                                title={
                                  isLimitExceeded && isCustomer
                                    ? TOOLTIP_MSG
                                    : null
                                }
                              >
                                <DownloadOutlined
                                  style={{
                                    cursor:
                                      isLimitExceeded && isCustomer
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                  onClick={() =>
                                    isLimitExceeded && isCustomer
                                      ? null
                                      : handleUsageUpdate(robotId, item)
                                  }
                                />
                              </Tooltip>
                            </a>
                          </span>
                        ) : (
                          <LoadingOutlined />
                        ),
                      ]}
                    >
                      {item.fileName}
                    </List.Item>
                  );
                } else {
                  return (
                    <List.Item>
                      No Daily report found on {selectedDate}
                    </List.Item>
                  );
                }
              }
            )}
            <b>Weld</b>
            {filteredWeldRun.length > 0 ? (
              filteredWeldRun.map((item, index) => {
                const video = getVideoLink(videos, item);
                const tsv = getNovDataLogLink(novdata_logs, item);

                return (
                  <List.Item
                    actions={[
                      video ? (
                        <span>
                          Video{" "}
                          <Tooltip
                            title={
                              isLimitExceeded && isCustomer ? TOOLTIP_MSG : null
                            }
                          >
                            <PlaySquareOutlined
                              style={{
                                cursor:
                                  isLimitExceeded && isCustomer
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() =>
                                isLimitExceeded && isCustomer
                                  ? null
                                  : isNovEyeH265 && !(isEdge || isSafari)
                                  ? message.error(WARNING, 5)
                                  : handleModalPreviewOpen(video)
                              }
                            />
                          </Tooltip>{" "}
                          <a
                            style={{ color: "rgba(0, 0, 0, 0.45)" }}
                            href={
                              isLimitExceeded && isCustomer
                                ? null
                                : (video && video.url) || null
                            }
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Tooltip
                              title={
                                isLimitExceeded && isCustomer
                                  ? TOOLTIP_MSG
                                  : null
                              }
                            >
                              <DownloadOutlined
                                style={{
                                  cursor:
                                    isLimitExceeded && isCustomer
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={() =>
                                  isLimitExceeded && isCustomer
                                    ? null
                                    : isNovEyeH265 && !(isEdge || isSafari)
                                    ? message.error(WARNING, 5)
                                    : handleUsageUpdate(robotId, video)
                                }
                              />
                            </Tooltip>
                          </a>
                        </span>
                      ) : (
                        <LoadingOutlined />
                      ),
                      tsv ? (
                        <span>
                          NovData{" "}
                          <a
                            style={{ color: "rgba(0, 0, 0, 0.45)" }}
                            href={
                              isLimitExceeded && isCustomer
                                ? null
                                : (tsv && tsv.url) || null
                            }
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Tooltip
                              title={
                                isLimitExceeded && isCustomer
                                  ? TOOLTIP_MSG
                                  : null
                              }
                            >
                              <DownloadOutlined
                                style={{
                                  cursor:
                                    isLimitExceeded && isCustomer
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                                onClick={() =>
                                  isLimitExceeded && isCustomer
                                    ? null
                                    : handleUsageUpdate(robotId, tsv)
                                }
                                // onClick={() => handleModalPreviewOpen(tsv)}
                              />
                            </Tooltip>
                          </a>
                        </span>
                      ) : (
                        <LoadingOutlined />
                      ),
                    ]}
                  >
                    <span>{`${index + 1} ${item.work_order_ref} ${
                      item.spool_ref
                    } ${item.welder_id_ref} ${item.run_number} ${
                      item.operator_name
                    }`}</span>{" "}
                    {/* {fileSize(item.size)} */}
                  </List.Item>
                );
              })
            ) : (
              <List.Item>No Weld found on {selectedDate}</List.Item>
            )}
          </List>
        </Modal>
      )}

      {!!selectedItem && (
        <Modal
          visible={modalPreviewOpen}
          centered
          bodyStyle={{ height: "80vh" }}
          width={"70%"}
          onOk={handleModalPreviewClose}
          onCancel={handleModalPreviewClose}
        >
          <DisplayFile
            item={{
              ...selectedItem,
              name: selectedItem.fileName,
              download: selectedItem.url,
            }}
            // selectedNovEyeLog={selectedNovEyeLog}
            selectedNovDataLog={selectedNovDataLog}
          />
        </Modal>
      )}
    </>
  );
}

const DisplayFile = ({ item, selectedNovDataLog, selectedNovEyeLog }) => {
  const extension = item && item.fileName && item.fileName.split(".");
  const type = extension[extension.length - 1];
  switch (type) {
    case "mp4":
      return (
        <VideoPlayer
          item={item}
          searchText={item.fileName}
          truncatedVideoName={item.fileName}
        ></VideoPlayer>
      );

    case "pdf":
      return <PDFViewer item={{ ...item, download: item.url }}></PDFViewer>;

    case "log":
      return <span style={{ whiteSpace: "pre" }}>{selectedNovEyeLog}</span>;

    case "tsv":
      return <span style={{ whiteSpace: "pre" }}>{selectedNovDataLog}</span>;
    default:
      return null;
  }
};

// Find corresponding video files based on job information
// Video files with timestamp will not be searchable
const getVideoLink = (list, item) => {
  // NovEye. .mp4
  // weld_vision. .mp4
  // workOrder_spoolId_welderId_RunNumber.mp4

  const file = find(list, (i) => {
    return i.fileName.includes(
      `${item.work_order_ref}_${item.spool_ref}_${item.welder_id_ref}-${item.run_number}.mp4`
    );
  });

  return file || null;
};

// Find corresponding novdata logs based on job information
const getNovDataLogLink = (list, item) => {
  const file = find(list, (i) => {
    return i.fileName.includes(
      `${item.work_order_ref}_${item.spool_ref}_${item.welder_id_ref}_${item.run_number}.tsv`
    );
  });

  return file || null;
};

// Find corresponding daily report based on job information
const getDailyReport = (list, item) => {
  const file = find(list, (i) => {
    return i.fileName.includes(
      `${moment(item.arc_on_utc).format("YYYY-MM-DD")}`
    );
  });

  return file || null;
};

const loadData = (data, current_files = {}) => {
  const {
    videos: local_videos,
    tsv: local_novdata_logs,
    reports: local_daily_reports,
    noveye_logs: local_noveye_logs,
  } = current_files;

  const {
    videos: cloud_videos,
    reports: cloud_daily_reports,
    novdata_logs: cloud_novdata_logs,
    noveye_logs: cloud_noveye_logs,
  } = data;

  const merged_videos = mergeObject(cloud_videos, local_videos);

  const merged_daily_reports = mergeObject(
    cloud_daily_reports,
    local_daily_reports
  );
  const merged_novdata_logs = mergeObject(
    cloud_novdata_logs,
    local_novdata_logs
  );

  const merged_noveye_logs = mergeObject(cloud_noveye_logs, local_noveye_logs);

  const dates = filter([
    ...getDates(merged_videos),
    ...getDates(merged_daily_reports),
    ...getDates(merged_novdata_logs),
    ...getDates(merged_noveye_logs),
  ]).sort((a, b) => a - b);

  const work_order_ref = uniqBy(
    [
      ...getWorkOrderAndSpoolId(merged_videos),
      ...getWorkOrderAndSpoolId(merged_daily_reports),
      ...getWorkOrderAndSpoolId(merged_novdata_logs),
      ...getWorkOrderAndSpoolId(merged_noveye_logs),
    ],
    "value"
  );

  return {
    merged_videos,
    merged_daily_reports,
    merged_novdata_logs,
    merged_noveye_logs,
    dates,
    work_order_ref: work_order_ref,
    // spool_ref: spool_ref,
  };
};

const geAllData = (data, selectedDate, keyword) => {
  const {
    merged_videos,
    merged_daily_reports,
    merged_novdata_logs,
    merged_noveye_logs,
  } = data;

  const searched_videos =
    searchObject(merged_videos, selectedDate, keyword) || [];
  const searched_daily_reports =
    searchObject(merged_daily_reports, selectedDate, keyword) || [];
  const searched_novdata_logs =
    searchObject(merged_novdata_logs, selectedDate, keyword) || [];
  const searched_noveye_logs =
    searchObject(merged_noveye_logs, selectedDate, keyword) || [];

  return [
    {
      title: `Video (${searched_videos.length})`,
      key: "videos",
      children: searched_videos,
    },
    {
      title: `Daily Report (${searched_daily_reports.length})`,
      key: "reports",
      children: searched_daily_reports,
    },
    {
      title: `NovData Log (${searched_novdata_logs.length})`,
      key: "tsv",
      children: searched_novdata_logs,
    },
    {
      title: `NovEye Log (${searched_noveye_logs.length})`,
      key: "noveye_logs",
      children: searched_noveye_logs,
    },
  ];
};

const mergeObject = (cloudData, localData) => {
  const mergedData = map(cloudData, (item) => {
    item = { ...getInfoFromFileName(item) };

    map(localData, (obj) => {
      if (item.fileName === obj.file_name) {
        item = { ...item, ...obj };
      }
    });

    return { ...item, isLeaf: true };
  });

  return mergedData;
};

const searchObject = (list, date, keyword) => {
  return filter(list, (item) => {
    const isDateMatched =
      date ===
      moment(
        item.modified_time ||
          item.created_time ||
          item.extracted_time ||
          item.extracted_date ||
          item.extractedDate ||
          item.extractedTime ||
          item.uploadedAt
      ).format("YYYY-MM-DD");

    const isKeywordMatched =
      (item.fileName && item.fileName.includes(keyword)) ||
      (item.file_name && item.file_name.includes(keyword));

    if (!!date && keyword !== "") {
      return isDateMatched && isKeywordMatched;
    } else if (date) {
      return isDateMatched;
    } else if (keyword) {
      return isKeywordMatched;
    } else {
      return false;
    }
  });
};

const getInfoFromFileName = (item) => {
  const matchDateTime = [...item.fileName.matchAll(DATETIME_REGEX)][0];
  const matchDate = [...item.fileName.matchAll(DATE_REGEX)][0];
  const matchWeldInfo = [...item.fileName.matchAll(WELD_REGEX)][0];

  return {
    ...item,
    key: item.fileName,
    title: item.fileName,
    extractedTime: matchDateTime
      ? new Date(
          matchDateTime[1],
          parseInt(matchDateTime[2], 10) - 1,
          matchDateTime[3],
          matchDateTime[4],
          matchDateTime[5],
          matchDateTime[6]
        ).toISOString()
      : null,
    extractedDate: matchDate
      ? new Date(
          matchDate[1],
          parseInt(matchDate[2], 10) - 1,
          matchDate[3]
        ).toISOString()
      : null,
    weldInfo: matchWeldInfo
      ? {
          work_order_ref: matchWeldInfo[1],
          spool_ref: matchWeldInfo[2],
          welder_id_ref: matchWeldInfo[3],
          run_number: matchWeldInfo[4],
        }
      : null,
  };
};

const getDates = (list) => {
  return chain(list)
    .map((item) => {
      return moment(
        item.modified_time ||
          item.created_time ||
          item.extracted_time ||
          item.extracted_date ||
          item.extractedDate ||
          item.extractedTime ||
          item.uploadedAt
      ).format("YYYY-MM-DD");
    })
    .uniqBy()
    .value();
};

const getWorkOrderAndSpoolId = (list) => {
  return chain(list)
    .map((item) => {
      const value =
        (item &&
          item.weldInfo &&
          (item.weldInfo.work_order_ref.toLowerCase() ||
            item.weldInfo.spool_ref.toLowerCase())) ||
        (item.weld_info &&
          (item.weld_info.work_order_ref.toLowerCase() ||
            item.weld_info.spool_ref.toLowerCase()));

      return { value: value };
    })
    .uniqBy("value")
    .filter((item) => !!item.value)
    .value();
};

export default RobotSearchFiles;
